module.exports = __webpack_public_path__ + "site/img/snow.2a92156f.png";